import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Segmentqmq1glevgieu as Segment,
  closefimrnzr4lu35 as close,
  findSegmentInternal35lxp6iondi3q as findSegmentInternal,
  _SegmentOrClosed___get_segment__impl__jvcr9l2mjww16efupm8 as _SegmentOrClosed___get_segment__impl__jvcr9l,
  _SegmentOrClosed___get_isClosed__impl__qmxmlo1rgnwiimtgu6z as _SegmentOrClosed___get_isClosed__impl__qmxmlo,
  SegmentOrCloseds3xpxfs4wrg9 as SegmentOrClosed,
} from '../internal/ConcurrentLinkedList.mjs';
import { atomicfu$AtomicRefArray$ofNulls2kz3j9ehigwa3 as atomicfu$AtomicRefArray$ofNulls } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.common.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Waiter3lxa2a79zyo0g as Waiter } from '../Waiter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  callUndeliveredElement5xsmnofvtcme as callUndeliveredElement,
  callUndeliveredElementCatchingException6xwxmojd3rq1 as callUndeliveredElementCatchingException,
} from '../internal/OnUndeliveredElement.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
  convertToInty04h231mmjoh as convertToInt,
  shiftRight2gqph14wydb8s as shiftRight,
  subtract2orl8z9upxd9l as subtract,
  shiftLeft3tsh2sstjchzn as shiftLeft,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  recoverStackTrace3k4hvtb53ci4z as recoverStackTrace,
  recoverStackTrace2i3si2i8nvw1k as recoverStackTrace_0,
} from '../internal/StackTraceRecovery.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  getOrCreateCancellableContinuation2t1o0dr9l9i36 as getOrCreateCancellableContinuation,
  CancellableContinuationpb2x00mxmcbt as CancellableContinuation,
} from '../CancellableContinuation.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../CancellableContinuationImpl.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import {
  Companion_getInstance2vekrswsg6p6 as Companion_getInstance,
  ChannelResult2y4k69ac6y3du as ChannelResult,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
  ChannelResult__getOrNull_impl_f5e07h3a081spbk3eji as ChannelResult__getOrNull_impl_f5e07h,
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  close$default2suggcywjwe8g as close$default,
  cancel$default3v09jht7i082i as cancel$default,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
  SendChannel38sllbxw662ws as SendChannel,
} from './Channel.mjs';
import {
  SelectInstance2isepgzfsd8ur as SelectInstance,
  SelectImplementation59ci94k9x9wm as SelectImplementation,
  TrySelectDetailedResult_REREGISTER_getInstance22g7lc4gi2j6m as TrySelectDetailedResult_REREGISTER_getInstance,
  TrySelectDetailedResult_SUCCESSFUL_getInstancea5pcdnmhzdxt as TrySelectDetailedResult_SUCCESSFUL_getInstance,
} from '../selects/Select.mjs';
import {
  _InlineList___init__impl__z8n56m2gffjy7o3ep as _InlineList___init__impl__z8n56,
  InlineList__plus_impl_nuetvo25d08twmx1uk7 as InlineList__plus_impl_nuetvo,
  access$_get_holder__kkflengpb3tkfr49xk as access$_get_holder__kkflen,
} from '../internal/InlineList.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { last2n4gf5az1lkn4 as last } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { systemProp2qpti4y1f5b4b as systemProp } from '../internal/SystemProps.common.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from '../internal/Symbol.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL_SEGMENT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NULL_SEGMENT;
}
var NULL_SEGMENT;
function get_SEGMENT_SIZE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SEGMENT_SIZE;
}
var SEGMENT_SIZE;
function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
}
var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
function get_BUFFERED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return BUFFERED;
}
var BUFFERED;
function get_IN_BUFFER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return IN_BUFFER;
}
var IN_BUFFER;
function get_RESUMING_BY_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_RCV;
}
var RESUMING_BY_RCV;
function get_RESUMING_BY_EB() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_EB;
}
var RESUMING_BY_EB;
function get_POISONED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return POISONED;
}
var POISONED;
function get_DONE_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return DONE_RCV;
}
var DONE_RCV;
function get_INTERRUPTED_SEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_SEND;
}
var INTERRUPTED_SEND;
function get_INTERRUPTED_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_RCV;
}
var INTERRUPTED_RCV;
function get_CHANNEL_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CHANNEL_CLOSED;
}
var CHANNEL_CLOSED;
function get_SUSPEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND;
}
var SUSPEND;
function get_SUSPEND_NO_WAITER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND_NO_WAITER;
}
var SUSPEND_NO_WAITER;
function get_FAILED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return FAILED;
}
var FAILED;
function get_NO_RECEIVE_RESULT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_RECEIVE_RESULT;
}
var NO_RECEIVE_RESULT;
function get_CLOSE_HANDLER_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_CLOSED;
}
var CLOSE_HANDLER_CLOSED;
function get_CLOSE_HANDLER_INVOKED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_INVOKED;
}
var CLOSE_HANDLER_INVOKED;
function get_NO_CLOSE_CAUSE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_CLOSE_CAUSE;
}
var NO_CLOSE_CAUSE;
function setElementLazy($this, index, value) {
  // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
  $this.data_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
}
var ChannelSegmentClass;
function ChannelSegment() {
  if (ChannelSegmentClass === VOID) {
    class $ extends Segment() {
      constructor(id, prev, channel, pointers) {
        super(id, prev, pointers);
        this._channel_1 = channel;
        this.data_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
      }
      get_channel_dhi7tm_k$() {
        return ensureNotNull(this._channel_1);
      }
      get_numberOfSlots_n3mgwk_k$() {
        return get_SEGMENT_SIZE();
      }
      storeElement_gce1i0_k$(index, element) {
        setElementLazy(this, index, element);
      }
      getElement_ye1phr_k$(index) {
        return this.data_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
      }
      retrieveElement_j8ywl1_k$(index) {
        // Inline function 'kotlin.also' call
        var this_0 = this.getElement_ye1phr_k$(index);
        this.cleanElement_ob56q6_k$(index);
        return this_0;
      }
      cleanElement_ob56q6_k$(index) {
        setElementLazy(this, index, null);
      }
      getState_jak5mi_k$(index) {
        return this.data_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
      }
      setState_bwy33f_k$(index, value) {
        this.data_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
      }
      casState_u37dcn_k$(index, from, to) {
        return this.data_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
      }
      getAndSetState_5asfss_k$(index, update) {
        return this.data_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
      }
      onCancellation_4jec3b_k$(index, cause, context) {
        var isSender = index >= get_SEGMENT_SIZE();
        var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
        var element = this.getElement_ye1phr_k$(index_0);
        $l$loop: while (true) {
          var cur = this.getState_jak5mi_k$(index_0);
          var tmp;
          if (!(cur == null) ? isInterface(cur, Waiter()) : false) {
            tmp = true;
          } else {
            tmp = cur instanceof WaiterEB();
          }
          if (tmp) {
            var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
            if (this.casState_u37dcn_k$(index_0, cur, update)) {
              this.cleanElement_ob56q6_k$(index_0);
              this.onCancelledRequest_bhmu12_k$(index_0, !isSender);
              if (isSender) {
                var tmp0_safe_receiver = this.get_channel_dhi7tm_k$().onUndeliveredElement_1;
                if (tmp0_safe_receiver == null)
                  null;
                else {
                  callUndeliveredElement(tmp0_safe_receiver, element, context);
                }
              }
              return Unit_instance;
            }
          } else {
            if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
              this.cleanElement_ob56q6_k$(index_0);
              if (isSender) {
                var tmp1_safe_receiver = this.get_channel_dhi7tm_k$().onUndeliveredElement_1;
                if (tmp1_safe_receiver == null)
                  null;
                else {
                  callUndeliveredElement(tmp1_safe_receiver, element, context);
                }
              }
              return Unit_instance;
            } else {
              if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV())
                continue $l$loop;
              else {
                if (cur === get_DONE_RCV() || cur === get_BUFFERED())
                  return Unit_instance;
                else {
                  if (cur === get_CHANNEL_CLOSED())
                    return Unit_instance;
                  else {
                    // Inline function 'kotlin.error' call
                    var message = 'unexpected state: ' + toString(cur);
                    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
                  }
                }
              }
            }
          }
        }
      }
      onCancelledRequest_bhmu12_k$(index, receiver) {
        if (receiver) {
          var tmp = this.get_channel_dhi7tm_k$();
          var tmp0 = this.id_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_0 = multiply(tmp0, fromInt(other));
          var tmp$ret$1 = add(this_0, fromInt(index));
          tmp.waitExpandBufferCompletion_nil576_k$(tmp$ret$1);
        }
        this.onSlotCleaned_do6lqz_k$();
      }
    }
    initMetadataForClass($, 'ChannelSegment');
    ChannelSegmentClass = $;
  }
  return ChannelSegmentClass;
}
function onClosedHasNext($this) {
  $this.receiveResult_1 = get_CHANNEL_CLOSED();
  var tmp0_elvis_lhs = $this.$this_1.get_closeCause_gbqkm2_k$();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var cause = tmp;
  throw recoverStackTrace(cause);
}
function *hasNextOnNoWaiterSuspend($this, segment, index, r, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      $this.continuation_1 = cancellable;
      var tmp0 = $this.$this_1;
      var tmp2 = segment;
      var tmp4 = index;
      var tmp6 = r;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var waiter = $this;
      var updCellResult = updateCellReceive(tmp0, tmp2, tmp4, tmp6, waiter);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(tmp0, waiter, tmp2, tmp4);
      } else if (updCellResult === get_FAILED()) {
        if (tmp6 < tmp0.get_sendersCounter_mvbt0m_k$()) {
          tmp2.cleanPrev_rn0kss_k$();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = tmp0.receiveSegment_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (tmp0.get_isClosedForReceive_v0r77d_k$()) {
              onClosedHasNextNoWaiterSuspend($this);
              break $l$block_0;
            }
            var r_0 = tmp0.receivers_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_0, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$8 = modulo(r_0, fromInt(other_0));
            var i = convertToInt(tmp$ret$8);
            if (!(segment_0.id_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(tmp0, segment_0, i, r_0, waiter);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter()) : false) ? waiter : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (r_0 < tmp0.get_sendersCounter_mvbt0m_k$()) {
                segment_0.cleanPrev_rn0kss_k$();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
            } else {
              segment_0.cleanPrev_rn0kss_k$();
              $this.receiveResult_1 = updCellResult_0;
              $this.continuation_1 = null;
              var tmp0_safe_receiver = $this.$this_1.onUndeliveredElement_1;
              cancellable.resume_nf5g9e_k$(true, tmp0_safe_receiver == null ? null : bindCancellationFun($this.$this_1, tmp0_safe_receiver, updCellResult_0));
            }
            break $l$block_0;
          }
        }
      } else {
        tmp2.cleanPrev_rn0kss_k$();
        $this.receiveResult_1 = updCellResult;
        $this.continuation_1 = null;
        var tmp0_safe_receiver_0 = $this.$this_1.onUndeliveredElement_1;
        cancellable.resume_nf5g9e_k$(true, tmp0_safe_receiver_0 == null ? null : bindCancellationFun($this.$this_1, tmp0_safe_receiver_0, updCellResult));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.releaseClaimedReusableContinuation_mdg0s9_k$();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.getResult_fck196_k$();
  };
}
function onClosedHasNextNoWaiterSuspend($this) {
  var cont = ensureNotNull($this.continuation_1);
  $this.continuation_1 = null;
  $this.receiveResult_1 = get_CHANNEL_CLOSED();
  var cause = $this.$this_1.get_closeCause_gbqkm2_k$();
  if (cause == null) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
    cont.resumeWith_rk9gbt_k$(tmp$ret$1);
  } else {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace_0(cause, cont);
    var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.resumeWith_rk9gbt_k$(tmp$ret$3);
  }
}
function _get_bufferEndCounter__2d4hee($this) {
  return $this.bufferEnd_1.kotlinx$atomicfu$value;
}
function _get_isRendezvousOrUnlimited__3mdufi($this) {
  // Inline function 'kotlin.let' call
  var it = _get_bufferEndCounter__2d4hee($this);
  return it === 0n || it === 9223372036854775807n;
}
function *onClosedSend($this, element, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.initCancellability_shqc60_k$();
    $l$block: {
      var tmp0_safe_receiver = $this.onUndeliveredElement_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, $this.get_sendException_qpq1ry_k$());
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = recoverStackTrace_0(tmp1_safe_receiver, cancellable);
        var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception));
        cancellable.resumeWith_rk9gbt_k$(tmp$ret$7);
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      var exception_0 = $this.get_sendException_qpq1ry_k$();
      // Inline function 'kotlin.Companion.failure' call
      var exception_1 = recoverStackTrace_0(exception_0, cancellable);
      var tmp$ret$9 = _Result___init__impl__xyqfz8(createFailure(exception_1));
      cancellable.resumeWith_rk9gbt_k$(tmp$ret$9);
    }
    return cancellable.getResult_fck196_k$();
  });
  return Unit_instance;
}
function *sendOnNoWaiterSuspend($this, segment, index, element, s, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  (yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      var tmp0 = $this;
      var tmp2 = segment;
      var tmp4 = index;
      var tmp6 = element;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter' call
      var s_0 = s;
      switch (updateCellSend(tmp0, tmp2, tmp4, tmp6, s_0, cancellable, false)) {
        case 0:
          tmp2.cleanPrev_rn0kss_k$();
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.resumeWith_rk9gbt_k$(tmp$ret$7);
          break;
        case 1:
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$10 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.resumeWith_rk9gbt_k$(tmp$ret$10);
          break;
        case 2:
          prepareSenderForSuspension(tmp0, cancellable, tmp2, tmp4);
          break;
        case 4:
          if (s_0 < tmp0.get_receiversCounter_ne8ics_k$()) {
            tmp2.cleanPrev_rn0kss_k$();
          }

          onClosedSendOnNoWaiterSuspend($this, element, cancellable);
          break;
        case 5:
          tmp2.cleanPrev_rn0kss_k$();
          $l$block_5: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
            var segment_0 = access$_get_sendSegment__111kgq(tmp0).kotlinx$atomicfu$value;
            $l$loop_0: while (true) {
              var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s(tmp0).atomicfu$getAndIncrement$long();
              // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
              var s_1 = sendersAndCloseStatusCur & 1152921504606846975n;
              var closed = access$_get_isClosedForSend0__sm8f7a(tmp0, sendersAndCloseStatusCur);
              // Inline function 'kotlin.Long.div' call
              var other = get_SEGMENT_SIZE();
              var id = divide(s_1, fromInt(other));
              // Inline function 'kotlin.Long.rem' call
              var other_0 = get_SEGMENT_SIZE();
              var tmp$ret$15 = modulo(s_1, fromInt(other_0));
              var i = convertToInt(tmp$ret$15);
              if (!(segment_0.id_1 === id)) {
                var tmp0_elvis_lhs = access$findSegmentSend(tmp0, id, segment_0);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                  var tmp_0;
                  if (closed) {
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  } else {
                    continue $l$loop_0;
                  }
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                segment_0 = tmp;
              }
              switch (access$updateCellSend(tmp0, segment_0, i, tmp6, s_1, cancellable, closed)) {
                case 0:
                  segment_0.cleanPrev_rn0kss_k$();
                  // Inline function 'kotlin.coroutines.resume' call

                  // Inline function 'kotlin.Companion.success' call

                  var tmp$ret$19 = _Result___init__impl__xyqfz8(Unit_instance);
                  cancellable.resumeWith_rk9gbt_k$(tmp$ret$19);
                  break $l$block_5;
                case 1:
                  // Inline function 'kotlin.coroutines.resume' call

                  // Inline function 'kotlin.Companion.success' call

                  var tmp$ret$22 = _Result___init__impl__xyqfz8(Unit_instance);
                  cancellable.resumeWith_rk9gbt_k$(tmp$ret$22);
                  break $l$block_5;
                case 2:
                  if (closed) {
                    segment_0.onSlotCleaned_do6lqz_k$();
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  }

                  var tmp2_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter()) : false) ? cancellable : null;
                  if (tmp2_safe_receiver == null)
                    null;
                  else {
                    access$prepareSenderForSuspension(tmp0, tmp2_safe_receiver, segment_0, i);
                  }

                  break $l$block_5;
                case 4:
                  if (s_1 < tmp0.get_receiversCounter_ne8ics_k$()) {
                    segment_0.cleanPrev_rn0kss_k$();
                  }

                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                case 5:
                  segment_0.cleanPrev_rn0kss_k$();
                  continue $l$loop_0;
                case 3:
                  // Inline function 'kotlin.error' call

                  var message = 'unexpected';
                  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
              }
            }
          }

          break;
        default:
          // Inline function 'kotlin.error' call

          var message_0 = 'unexpected';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message_0));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.releaseClaimedReusableContinuation_mdg0s9_k$();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.getResult_fck196_k$();
  });
  return Unit_instance;
}
function prepareSenderForSuspension($this, $receiver, segment, index) {
  $receiver.invokeOnCancellation_effrxe_k$(segment, index + get_SEGMENT_SIZE() | 0);
}
function onClosedSendOnNoWaiterSuspend($this, element, cont) {
  var tmp0_safe_receiver = $this.onUndeliveredElement_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    callUndeliveredElement(tmp0_safe_receiver, element, cont.get_context_h02k06_k$());
  }
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = recoverStackTrace_0($this.get_sendException_qpq1ry_k$(), cont);
  var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.resumeWith_rk9gbt_k$(tmp$ret$1);
}
var SendBroadcastClass;
function SendBroadcast() {
  if (SendBroadcastClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SendBroadcast', VOID, VOID, [Waiter()]);
    SendBroadcastClass = $;
  }
  return SendBroadcastClass;
}
function updateCellSend($this, segment, index, element, s, waiter, closed) {
  segment.storeElement_gce1i0_k$(index, element);
  if (closed)
    return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
  var state = segment.getState_jak5mi_k$(index);
  if (state === null) {
    if (bufferOrRendezvousSend($this, s)) {
      if (segment.casState_u37dcn_k$(index, null, get_BUFFERED())) {
        return 1;
      }
    } else {
      if (waiter == null) {
        return 3;
      } else {
        if (segment.casState_u37dcn_k$(index, null, waiter))
          return 2;
      }
    }
  } else {
    if (isInterface(state, Waiter())) {
      segment.cleanElement_ob56q6_k$(index);
      var tmp;
      if (tryResumeReceiver($this, state, element)) {
        segment.setState_bwy33f_k$(index, get_DONE_RCV());
        $this.onReceiveDequeued_4w5qpk_k$();
        tmp = 0;
      } else {
        if (!(segment.getAndSetState_5asfss_k$(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.onCancelledRequest_bhmu12_k$(index, true);
        }
        tmp = 5;
      }
      return tmp;
    }
  }
  return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
}
function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
  while (true) {
    var state = segment.getState_jak5mi_k$(index);
    if (state === null) {
      if (bufferOrRendezvousSend($this, s) && !closed) {
        if (segment.casState_u37dcn_k$(index, null, get_BUFFERED())) {
          return 1;
        }
      } else {
        if (closed) {
          if (segment.casState_u37dcn_k$(index, null, get_INTERRUPTED_SEND())) {
            segment.onCancelledRequest_bhmu12_k$(index, false);
            return 4;
          }
        } else if (waiter == null)
          return 3;
        else if (segment.casState_u37dcn_k$(index, null, waiter))
          return 2;
      }
    } else if (state === get_IN_BUFFER()) {
      if (segment.casState_u37dcn_k$(index, state, get_BUFFERED())) {
        return 1;
      }
    } else if (state === get_INTERRUPTED_RCV()) {
      segment.cleanElement_ob56q6_k$(index);
      return 5;
    } else if (state === get_POISONED()) {
      segment.cleanElement_ob56q6_k$(index);
      return 5;
    } else if (state === get_CHANNEL_CLOSED()) {
      segment.cleanElement_ob56q6_k$(index);
      completeCloseOrCancel($this);
      return 4;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      segment.cleanElement_ob56q6_k$(index);
      var tmp;
      if (state instanceof WaiterEB()) {
        tmp = state.waiter_1;
      } else {
        tmp = state;
      }
      var receiver = tmp;
      var tmp_0;
      if (tryResumeReceiver($this, receiver, element)) {
        segment.setState_bwy33f_k$(index, get_DONE_RCV());
        $this.onReceiveDequeued_4w5qpk_k$();
        tmp_0 = 0;
      } else {
        if (!(segment.getAndSetState_5asfss_k$(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.onCancelledRequest_bhmu12_k$(index, true);
        }
        tmp_0 = 5;
      }
      return tmp_0;
    }
  }
}
function shouldSendSuspend0($this, curSendersAndCloseStatus) {
  if (_get_isClosedForSend0__kxgf9m($this, curSendersAndCloseStatus))
    return false;
  // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
  var tmp$ret$0 = curSendersAndCloseStatus & 1152921504606846975n;
  return !bufferOrRendezvousSend($this, tmp$ret$0);
}
function bufferOrRendezvousSend($this, curSenders) {
  var tmp;
  if (curSenders < _get_bufferEndCounter__2d4hee($this)) {
    tmp = true;
  } else {
    var tmp0 = $this.get_receiversCounter_ne8ics_k$();
    // Inline function 'kotlin.Long.plus' call
    var other = $this.capacity_1;
    tmp = curSenders < add(tmp0, fromInt(other));
  }
  return tmp;
}
function tryResumeReceiver($this, $receiver, element) {
  var tmp;
  if (isInterface($receiver, SelectInstance())) {
    tmp = $receiver.trySelect_fbege0_k$($this, element);
  } else {
    if ($receiver instanceof ReceiveCatching()) {
      if (!($receiver instanceof ReceiveCatching()))
        THROW_CCE();
      var tmp_0 = Companion_getInstance().success_tizbw6_k$(element);
      var tmp1_safe_receiver = $this.onUndeliveredElement_1;
      tmp = tryResume0($receiver.cont_1, new (ChannelResult())(tmp_0), tmp1_safe_receiver == null ? null : bindCancellationFunResult($this, tmp1_safe_receiver));
    } else {
      if ($receiver instanceof BufferedChannelIterator()) {
        if (!($receiver instanceof BufferedChannelIterator()))
          THROW_CCE();
        tmp = $receiver.tryResumeHasNext_yugi5j_k$(element);
      } else {
        if (isInterface($receiver, CancellableContinuation())) {
          if (!isInterface($receiver, CancellableContinuation()))
            THROW_CCE();
          var tmp2_safe_receiver = $this.onUndeliveredElement_1;
          tmp = tryResume0($receiver, element, tmp2_safe_receiver == null ? null : bindCancellationFun_0($this, tmp2_safe_receiver));
        } else {
          // Inline function 'kotlin.error' call
          var message = 'Unexpected receiver type: ' + toString_0($receiver);
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
        }
      }
    }
  }
  return tmp;
}
function *receiveOnNoWaiterSuspend($this, segment, index, r, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = getOrCreateCancellableContinuation(intercepted(uCont));
    try {
      var tmp0 = $this;
      var tmp2 = segment;
      var tmp4 = index;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var r_0 = r;
      var updCellResult = updateCellReceive(tmp0, tmp2, tmp4, r_0, cancellable);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(tmp0, cancellable, tmp2, tmp4);
      } else if (updCellResult === get_FAILED()) {
        if (r_0 < tmp0.get_sendersCounter_mvbt0m_k$()) {
          tmp2.cleanPrev_rn0kss_k$();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = tmp0.receiveSegment_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (tmp0.get_isClosedForReceive_v0r77d_k$()) {
              onClosedReceiveOnNoWaiterSuspend($this, cancellable);
              break $l$block_0;
            }
            var r_1 = tmp0.receivers_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_1, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$8 = modulo(r_1, fromInt(other_0));
            var i = convertToInt(tmp$ret$8);
            if (!(segment_0.id_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(tmp0, segment_0, i, r_1, cancellable);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter()) : false) ? cancellable : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (r_1 < tmp0.get_sendersCounter_mvbt0m_k$()) {
                segment_0.cleanPrev_rn0kss_k$();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
            } else {
              segment_0.cleanPrev_rn0kss_k$();
              var tmp0_safe_receiver = $this.onUndeliveredElement_1;
              var onCancellation = tmp0_safe_receiver == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver);
              cancellable.resume_nf5g9e_k$(updCellResult_0, onCancellation);
            }
            break $l$block_0;
          }
        }
      } else {
        tmp2.cleanPrev_rn0kss_k$();
        var tmp0_safe_receiver_0 = $this.onUndeliveredElement_1;
        var onCancellation_0 = tmp0_safe_receiver_0 == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver_0);
        cancellable.resume_nf5g9e_k$(updCellResult, onCancellation_0);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.releaseClaimedReusableContinuation_mdg0s9_k$();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.getResult_fck196_k$();
  };
}
function prepareReceiverForSuspension($this, $receiver, segment, index) {
  $this.onReceiveEnqueued_xthhlc_k$();
  $receiver.invokeOnCancellation_effrxe_k$(segment, index);
}
function onClosedReceiveOnNoWaiterSuspend($this, cont) {
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = _get_receiveException__foorc1($this);
  var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.resumeWith_rk9gbt_k$(tmp$ret$1);
}
function updateCellReceive($this, segment, index, r, waiter) {
  var state = segment.getState_jak5mi_k$(index);
  if (state === null) {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var senders = $this.sendersAndCloseStatus_1.kotlinx$atomicfu$value & 1152921504606846975n;
    if (r >= senders) {
      if (waiter === null) {
        return get_SUSPEND_NO_WAITER();
      }
      if (segment.casState_u37dcn_k$(index, state, waiter)) {
        expandBuffer($this);
        return get_SUSPEND();
      }
    }
  } else if (state === get_BUFFERED())
    if (segment.casState_u37dcn_k$(index, state, get_DONE_RCV())) {
      expandBuffer($this);
      return segment.retrieveElement_j8ywl1_k$(index);
    }
  return updateCellReceiveSlow($this, segment, index, r, waiter);
}
function updateCellReceiveSlow($this, segment, index, r, waiter) {
  $l$loop: while (true) {
    var state = segment.getState_jak5mi_k$(index);
    if (state === null || state === get_IN_BUFFER()) {
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var senders = $this.sendersAndCloseStatus_1.kotlinx$atomicfu$value & 1152921504606846975n;
      if (r < senders) {
        if (segment.casState_u37dcn_k$(index, state, get_POISONED())) {
          expandBuffer($this);
          return get_FAILED();
        }
      } else {
        if (waiter === null) {
          return get_SUSPEND_NO_WAITER();
        }
        if (segment.casState_u37dcn_k$(index, state, waiter)) {
          expandBuffer($this);
          return get_SUSPEND();
        }
      }
    } else if (state === get_BUFFERED()) {
      if (segment.casState_u37dcn_k$(index, state, get_DONE_RCV())) {
        expandBuffer($this);
        return segment.retrieveElement_j8ywl1_k$(index);
      }
    } else if (state === get_INTERRUPTED_SEND())
      return get_FAILED();
    else if (state === get_POISONED())
      return get_FAILED();
    else if (state === get_CHANNEL_CLOSED()) {
      expandBuffer($this);
      return get_FAILED();
    } else if (state === get_RESUMING_BY_EB())
      continue $l$loop;
    else {
      if (segment.casState_u37dcn_k$(index, state, get_RESUMING_BY_RCV())) {
        var helpExpandBuffer = state instanceof WaiterEB();
        var tmp;
        if (state instanceof WaiterEB()) {
          tmp = state.waiter_1;
        } else {
          tmp = state;
        }
        var sender = tmp;
        var tmp_0;
        if (tryResumeSender($this, sender, segment, index)) {
          segment.setState_bwy33f_k$(index, get_DONE_RCV());
          expandBuffer($this);
          tmp_0 = segment.retrieveElement_j8ywl1_k$(index);
        } else {
          segment.setState_bwy33f_k$(index, get_INTERRUPTED_SEND());
          segment.onCancelledRequest_bhmu12_k$(index, false);
          if (helpExpandBuffer) {
            expandBuffer($this);
          }
          tmp_0 = get_FAILED();
        }
        return tmp_0;
      }
    }
  }
}
function tryResumeSender($this, $receiver, segment, index) {
  var tmp;
  if (isInterface($receiver, CancellableContinuation())) {
    if (!isInterface($receiver, CancellableContinuation()))
      THROW_CCE();
    tmp = tryResume0($receiver, Unit_instance);
  } else {
    if (isInterface($receiver, SelectInstance())) {
      if (!($receiver instanceof SelectImplementation()))
        THROW_CCE();
      var trySelectResult = $receiver.trySelectDetailed_t8yc08_k$($this, Unit_instance);
      if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) {
        segment.cleanElement_ob56q6_k$(index);
      }
      tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
    } else {
      if ($receiver instanceof SendBroadcast()) {
        tmp = tryResume0($receiver.cont_1, true);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'Unexpected waiter: ' + toString_0($receiver);
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
      }
    }
  }
  return tmp;
}
function expandBuffer($this) {
  if (_get_isRendezvousOrUnlimited__3mdufi($this))
    return Unit_instance;
  var segment = $this.bufferEndSegment_1.kotlinx$atomicfu$value;
  try_again: while (true) {
    var b = $this.bufferEnd_1.atomicfu$getAndIncrement$long();
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = divide(b, fromInt(other));
    var s = $this.get_sendersCounter_mvbt0m_k$();
    if (s <= b) {
      if (segment.id_1 < id && !(segment.get_next_wor1vg_k$() == null)) {
        moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
      }
      incCompletedExpandBufferAttempts($this);
      return Unit_instance;
    }
    if (!(segment.id_1 === id)) {
      var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue try_again;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var tmp$ret$1 = modulo(b, fromInt(other_0));
    var i = convertToInt(tmp$ret$1);
    if (updateCellExpandBuffer($this, segment, i, b)) {
      incCompletedExpandBufferAttempts($this);
      return Unit_instance;
    } else {
      incCompletedExpandBufferAttempts($this);
      continue try_again;
    }
  }
}
function updateCellExpandBuffer($this, segment, index, b) {
  var state = segment.getState_jak5mi_k$(index);
  if (!(state == null) ? isInterface(state, Waiter()) : false) {
    if (b >= $this.receivers_1.kotlinx$atomicfu$value) {
      if (segment.casState_u37dcn_k$(index, state, get_RESUMING_BY_EB())) {
        var tmp;
        if (tryResumeSender($this, state, segment, index)) {
          segment.setState_bwy33f_k$(index, get_BUFFERED());
          tmp = true;
        } else {
          segment.setState_bwy33f_k$(index, get_INTERRUPTED_SEND());
          segment.onCancelledRequest_bhmu12_k$(index, false);
          tmp = false;
        }
        return tmp;
      }
    }
  }
  return updateCellExpandBufferSlow($this, segment, index, b);
}
function updateCellExpandBufferSlow($this, segment, index, b) {
  $l$loop: while (true) {
    var state = segment.getState_jak5mi_k$(index);
    if (!(state == null) ? isInterface(state, Waiter()) : false) {
      if (b < $this.receivers_1.kotlinx$atomicfu$value) {
        if (segment.casState_u37dcn_k$(index, state, new (WaiterEB())(state)))
          return true;
      } else {
        if (segment.casState_u37dcn_k$(index, state, get_RESUMING_BY_EB())) {
          var tmp;
          if (tryResumeSender($this, state, segment, index)) {
            segment.setState_bwy33f_k$(index, get_BUFFERED());
            tmp = true;
          } else {
            segment.setState_bwy33f_k$(index, get_INTERRUPTED_SEND());
            segment.onCancelledRequest_bhmu12_k$(index, false);
            tmp = false;
          }
          return tmp;
        }
      }
    } else {
      if (state === get_INTERRUPTED_SEND())
        return false;
      else {
        if (state === null) {
          if (segment.casState_u37dcn_k$(index, state, get_IN_BUFFER()))
            return true;
        } else {
          if (state === get_BUFFERED())
            return true;
          else {
            if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV())
              return true;
            else {
              if (state === get_CHANNEL_CLOSED())
                return true;
              else {
                if (state === get_RESUMING_BY_RCV())
                  continue $l$loop;
                else {
                  // Inline function 'kotlin.error' call
                  var message = 'Unexpected cell state: ' + toString_0(state);
                  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
                }
              }
            }
          }
        }
      }
    }
  }
}
function incCompletedExpandBufferAttempts($this, nAttempts) {
  nAttempts = nAttempts === VOID ? 1n : nAttempts;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
  if (!(($this.completedExpandBuffersAndPauseFlag_1.atomicfu$addAndGet$long(nAttempts) & 4611686018427387904n) === 0n)) {
    $l$loop: while (true) {
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      if (!!(($this.completedExpandBuffersAndPauseFlag_1.kotlinx$atomicfu$value & 4611686018427387904n) === 0n)) {
        break $l$loop;
      }
    }
  }
}
var BufferedChannelIteratorClass;
function BufferedChannelIterator() {
  if (BufferedChannelIteratorClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.receiveResult_1 = get_NO_RECEIVE_RESULT();
        this.continuation_1 = null;
      }
      *hasNext_nhy1w3_k$($completion) {
        var tmp;
        if (!(this.receiveResult_1 === get_NO_RECEIVE_RESULT()) && !(this.receiveResult_1 === get_CHANNEL_CLOSED())) {
          tmp = true;
        } else {
          var tmp0 = this.$this_1;
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
            var segment = tmp0.receiveSegment_1.kotlinx$atomicfu$value;
            $l$loop_0: while (true) {
              if (tmp0.get_isClosedForReceive_v0r77d_k$()) {
                tmp$ret$0 = onClosedHasNext(this);
                break $l$block_0;
              }
              var r = tmp0.receivers_1.atomicfu$getAndIncrement$long();
              // Inline function 'kotlin.Long.div' call
              var other = get_SEGMENT_SIZE();
              var id = divide(r, fromInt(other));
              // Inline function 'kotlin.Long.rem' call
              var other_0 = get_SEGMENT_SIZE();
              var tmp$ret$3 = modulo(r, fromInt(other_0));
              var i = convertToInt(tmp$ret$3);
              if (!(segment.id_1 === id)) {
                var tmp0_elvis_lhs = findSegmentReceive(tmp0, id, segment);
                var tmp_0;
                if (tmp0_elvis_lhs == null) {
                  continue $l$loop_0;
                } else {
                  tmp_0 = tmp0_elvis_lhs;
                }
                segment = tmp_0;
              }
              var updCellResult = updateCellReceive(tmp0, segment, i, r, null);
              var tmp_1;
              if (updCellResult === get_SUSPEND()) {
                var tmp1_safe_receiver = (!(null == null) ? isInterface(null, Waiter()) : false) ? null : null;
                if (tmp1_safe_receiver == null)
                  null;
                else {
                  prepareReceiverForSuspension(tmp0, tmp1_safe_receiver, segment, i);
                }
                // Inline function 'kotlin.error' call
                var message = 'unreachable';
                throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
              } else if (updCellResult === get_FAILED()) {
                if (r < tmp0.get_sendersCounter_mvbt0m_k$()) {
                  segment.cleanPrev_rn0kss_k$();
                }
                continue $l$loop_0;
              } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
                var segm = segment;
                return yield* /*#__NOINLINE__*/hasNextOnNoWaiterSuspend(this, segm, i, r, $completion);
              } else {
                segment.cleanPrev_rn0kss_k$();
                this.receiveResult_1 = updCellResult;
                tmp_1 = true;
              }
              tmp$ret$0 = tmp_1;
              break $l$block_0;
            }
          }
          tmp = tmp$ret$0;
        }
        return tmp;
      }
      invokeOnCancellation_effrxe_k$(segment, index) {
        var tmp0_safe_receiver = this.continuation_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.invokeOnCancellation_effrxe_k$(segment, index);
        }
      }
      next_20eer_k$() {
        var result = this.receiveResult_1;
        // Inline function 'kotlin.check' call
        if (!!(result === get_NO_RECEIVE_RESULT())) {
          var message = '`hasNext()` has not been invoked';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
        }
        this.receiveResult_1 = get_NO_RECEIVE_RESULT();
        if (result === get_CHANNEL_CLOSED())
          throw recoverStackTrace(_get_receiveException__foorc1(this.$this_1));
        return result;
      }
      tryResumeHasNext_yugi5j_k$(element) {
        var cont = ensureNotNull(this.continuation_1);
        this.continuation_1 = null;
        this.receiveResult_1 = element;
        var tmp0_safe_receiver = this.$this_1.onUndeliveredElement_1;
        return tryResume0(cont, true, tmp0_safe_receiver == null ? null : bindCancellationFun(this.$this_1, tmp0_safe_receiver, element));
      }
      tryResumeHasNextOnClosedChannel_mc581v_k$() {
        var cont = ensureNotNull(this.continuation_1);
        this.continuation_1 = null;
        this.receiveResult_1 = get_CHANNEL_CLOSED();
        var cause = this.$this_1.get_closeCause_gbqkm2_k$();
        if (cause == null) {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
          cont.resumeWith_rk9gbt_k$(tmp$ret$1);
        } else {
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception = recoverStackTrace_0(cause, cont);
          var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
          cont.resumeWith_rk9gbt_k$(tmp$ret$3);
        }
      }
    }
    initMetadataForClass($, 'BufferedChannelIterator', VOID, VOID, [Waiter()], [0, 3]);
    BufferedChannelIteratorClass = $;
  }
  return BufferedChannelIteratorClass;
}
function _get_receiveException__foorc1($this) {
  var tmp0_elvis_lhs = $this.get_closeCause_gbqkm2_k$();
  return tmp0_elvis_lhs == null ? ClosedReceiveChannelException().new_kotlinx_coroutines_channels_ClosedReceiveChannelException_np7nzq_k$('Channel was closed') : tmp0_elvis_lhs;
}
function invokeCloseHandler($this) {
  var tmp0 = $this.closeHandler_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.getAndUpdate' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      if (cur === null) {
        tmp = get_CLOSE_HANDLER_CLOSED();
      } else {
        tmp = get_CLOSE_HANDLER_INVOKED();
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = cur;
        break $l$block;
      }
    }
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var closeHandler = tmp_0;
  if (typeof closeHandler !== 'function')
    THROW_CCE();
  closeHandler($this.get_closeCause_gbqkm2_k$());
}
function markClosed($this) {
  var tmp0 = $this.sendersAndCloseStatus_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      var tmp;
      switch (convertToInt(shiftRight(cur, 60))) {
        case 0:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$3 = cur & 1152921504606846975n;
          tmp = constructSendersAndCloseStatus(tmp$ret$3, 2);
          break;
        case 1:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$4 = cur & 1152921504606846975n;
          tmp = constructSendersAndCloseStatus(tmp$ret$4, 3);
          break;
        default:
          return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
function markCancelled($this) {
  var tmp0 = $this.sendersAndCloseStatus_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var tmp$ret$2 = cur & 1152921504606846975n;
      var upd = constructSendersAndCloseStatus(tmp$ret$2, 3);
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
function markCancellationStarted($this) {
  var tmp0 = $this.sendersAndCloseStatus_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      if (convertToInt(shiftRight(cur, 60)) === 0) {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var tmp$ret$3 = cur & 1152921504606846975n;
        tmp = constructSendersAndCloseStatus(tmp$ret$3, 1);
      } else {
        return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
function completeCloseOrCancel($this) {
  $this.get_isClosedForSend_ajczci_k$();
}
function completeClose($this, sendersCur) {
  var lastSegment = closeLinkedList($this);
  if ($this.get_isConflatedDropOldest_qp2q39_k$()) {
    var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
    if (!(lastBufferedCellGlobalIndex === -1n)) {
      $this.dropFirstElementUntilTheSpecifiedCellIsInTheBuffer_l7hcju_k$(lastBufferedCellGlobalIndex);
    }
  }
  cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
  return lastSegment;
}
function completeCancel($this, sendersCur) {
  var lastSegment = completeClose($this, sendersCur);
  removeUnprocessedElements($this, lastSegment);
}
function closeLinkedList($this) {
  var lastSegment = $this.bufferEndSegment_1.kotlinx$atomicfu$value;
  // Inline function 'kotlin.let' call
  var it = $this.sendSegment_1.kotlinx$atomicfu$value;
  if (it.id_1 > lastSegment.id_1)
    lastSegment = it;
  // Inline function 'kotlin.let' call
  var it_0 = $this.receiveSegment_1.kotlinx$atomicfu$value;
  if (it_0.id_1 > lastSegment.id_1)
    lastSegment = it_0;
  return close(lastSegment);
}
function markAllEmptyCellsAsClosed($this, lastSegment) {
  var segment = lastSegment;
  while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.id_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        var globalIndex = add(this_0, fromInt(index));
        if (globalIndex < $this.get_receiversCounter_ne8ics_k$())
          return -1n;
        cell_update: while (true) {
          var state = segment.getState_jak5mi_k$(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.casState_u37dcn_k$(index, state, get_CHANNEL_CLOSED())) {
              segment.onSlotCleaned_do6lqz_k$();
              break cell_update;
            }
          } else if (state === get_BUFFERED())
            return globalIndex;
          else
            break cell_update;
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.get_prev_wosl18_k$();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return -1n;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
}
function removeUnprocessedElements($this, lastSegment) {
  var onUndeliveredElement = $this.onUndeliveredElement_1;
  var undeliveredElementException = null;
  var suspendedSenders = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.id_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        var globalIndex = add(this_0, fromInt(index));
        update_cell: while (true) {
          var state = segment.getState_jak5mi_k$(index);
          if (state === get_DONE_RCV())
            break process_segments;
          else {
            if (state === get_BUFFERED()) {
              if (globalIndex < $this.get_receiversCounter_ne8ics_k$())
                break process_segments;
              if (segment.casState_u37dcn_k$(index, state, get_CHANNEL_CLOSED())) {
                if (!(onUndeliveredElement == null)) {
                  var element = segment.getElement_ye1phr_k$(index);
                  undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                }
                segment.cleanElement_ob56q6_k$(index);
                segment.onSlotCleaned_do6lqz_k$();
                break update_cell;
              }
            } else {
              if (state === get_IN_BUFFER() || state === null) {
                if (segment.casState_u37dcn_k$(index, state, get_CHANNEL_CLOSED())) {
                  segment.onSlotCleaned_do6lqz_k$();
                  break update_cell;
                }
              } else {
                var tmp;
                if (isInterface(state, Waiter())) {
                  tmp = true;
                } else {
                  tmp = state instanceof WaiterEB();
                }
                if (tmp) {
                  if (globalIndex < $this.get_receiversCounter_ne8ics_k$())
                    break process_segments;
                  var tmp_0;
                  if (state instanceof WaiterEB()) {
                    tmp_0 = state.waiter_1;
                  } else {
                    tmp_0 = isInterface(state, Waiter()) ? state : THROW_CCE();
                  }
                  var sender = tmp_0;
                  if (segment.casState_u37dcn_k$(index, state, get_CHANNEL_CLOSED())) {
                    if (!(onUndeliveredElement == null)) {
                      var element_0 = segment.getElement_ye1phr_k$(index);
                      undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                    }
                    suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                    segment.cleanElement_ob56q6_k$(index);
                    segment.onSlotCleaned_do6lqz_k$();
                    break update_cell;
                  }
                } else {
                  if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV())
                    break process_segments;
                  else {
                    if (state === get_RESUMING_BY_EB())
                      continue update_cell;
                    else {
                      break update_cell;
                    }
                  }
                }
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.get_prev_wosl18_k$();
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      break process_segments;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    segment = tmp_1;
  }
  var tmp0_0 = suspendedSenders;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList())) {
        var tmp_2 = access$_get_holder__kkflen(tmp0_0);
        var it = !(tmp_2 == null) ? tmp_2 : THROW_CCE();
        resumeSenderOnCancelledChannel($this, it);
      } else {
        var tmp_3 = access$_get_holder__kkflen(tmp0_0);
        var list = tmp_3 instanceof ArrayList() ? tmp_3 : THROW_CCE();
        var inductionVariable_0 = list.get_size_woubt6_k$() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.get_c1px32_k$(i);
            resumeSenderOnCancelledChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  var tmp1_safe_receiver = undeliveredElementException;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp1_safe_receiver;
  }
}
function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
  var suspendedReceivers = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (!(segment == null)) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.id_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        if (add(this_0, fromInt(index)) < sendersCounter)
          break process_segments;
        cell_update: while (true) {
          var state = segment.getState_jak5mi_k$(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.casState_u37dcn_k$(index, state, get_CHANNEL_CLOSED())) {
              segment.onSlotCleaned_do6lqz_k$();
              break cell_update;
            }
          } else {
            if (state instanceof WaiterEB()) {
              if (segment.casState_u37dcn_k$(index, state, get_CHANNEL_CLOSED())) {
                suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.waiter_1);
                segment.onCancelledRequest_bhmu12_k$(index, true);
                break cell_update;
              }
            } else {
              if (isInterface(state, Waiter())) {
                if (segment.casState_u37dcn_k$(index, state, get_CHANNEL_CLOSED())) {
                  suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                  segment.onCancelledRequest_bhmu12_k$(index, true);
                  break cell_update;
                }
              } else {
                break cell_update;
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    segment = segment.get_prev_wosl18_k$();
  }
  var tmp0_0 = suspendedReceivers;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList())) {
        var tmp = access$_get_holder__kkflen(tmp0_0);
        var it = !(tmp == null) ? tmp : THROW_CCE();
        resumeReceiverOnClosedChannel($this, it);
      } else {
        var tmp_0 = access$_get_holder__kkflen(tmp0_0);
        var list = tmp_0 instanceof ArrayList() ? tmp_0 : THROW_CCE();
        var inductionVariable_0 = list.get_size_woubt6_k$() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.get_c1px32_k$(i);
            resumeReceiverOnClosedChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
}
function resumeReceiverOnClosedChannel($this, $receiver) {
  return resumeWaiterOnClosedChannel($this, $receiver, true);
}
function resumeSenderOnCancelledChannel($this, $receiver) {
  return resumeWaiterOnClosedChannel($this, $receiver, false);
}
function resumeWaiterOnClosedChannel($this, $receiver, receiver) {
  if ($receiver instanceof SendBroadcast()) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $receiver.cont_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
    this_0.resumeWith_rk9gbt_k$(tmp$ret$1);
  } else {
    if (isInterface($receiver, CancellableContinuation())) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = receiver ? _get_receiveException__foorc1($this) : $this.get_sendException_qpq1ry_k$();
      var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
      $receiver.resumeWith_rk9gbt_k$(tmp$ret$3);
    } else {
      if ($receiver instanceof ReceiveCatching()) {
        var tmp0 = $receiver.cont_1;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = new (ChannelResult())(Companion_getInstance().closed_xuwu5z_k$($this.get_closeCause_gbqkm2_k$()));
        var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
        tmp0.resumeWith_rk9gbt_k$(tmp$ret$5);
      } else {
        if ($receiver instanceof BufferedChannelIterator()) {
          $receiver.tryResumeHasNextOnClosedChannel_mc581v_k$();
        } else {
          if (isInterface($receiver, SelectInstance()))
            $receiver.trySelect_fbege0_k$($this, get_CHANNEL_CLOSED());
          else {
            // Inline function 'kotlin.error' call
            var message = 'Unexpected waiter: ' + toString_0($receiver);
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
          }
        }
      }
    }
  }
}
function _get_isClosedForSend0__kxgf9m($this, $receiver) {
  return isClosed($this, $receiver, false);
}
function _get_isClosedForReceive0__f7qknl($this, $receiver) {
  return isClosed($this, $receiver, true);
}
function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
  // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
  var tmp;
  switch (convertToInt(shiftRight(sendersAndCloseStatusCur, 60))) {
    case 0:
      tmp = false;
      break;
    case 1:
      tmp = false;
      break;
    case 2:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$1 = sendersAndCloseStatusCur & 1152921504606846975n;
      completeClose($this, tmp$ret$1);
      tmp = isClosedForReceive ? !$this.hasElements_2busqs_k$() : true;
      break;
    case 3:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$2 = sendersAndCloseStatusCur & 1152921504606846975n;
      completeCancel($this, tmp$ret$2);
      tmp = true;
      break;
    default:
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call

      // Inline function 'kotlin.error' call

      var message = 'unexpected close status: ' + convertToInt(shiftRight(sendersAndCloseStatusCur, 60));
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
  }
  return tmp;
}
function isCellNonEmpty($this, segment, index, globalIndex) {
  while (true) {
    var state = segment.getState_jak5mi_k$(index);
    if (state === null || state === get_IN_BUFFER()) {
      if (segment.casState_u37dcn_k$(index, state, get_POISONED())) {
        expandBuffer($this);
        return false;
      }
    } else if (state === get_BUFFERED())
      return true;
    else if (state === get_INTERRUPTED_SEND())
      return false;
    else if (state === get_CHANNEL_CLOSED())
      return false;
    else if (state === get_DONE_RCV())
      return false;
    else if (state === get_POISONED())
      return false;
    else if (state === get_RESUMING_BY_EB())
      return true;
    else if (state === get_RESUMING_BY_RCV())
      return false;
    else
      return globalIndex === $this.get_receiversCounter_ne8ics_k$();
  }
}
function findSegmentSend($this, id, startFrom) {
  var tmp0 = $this.sendSegment_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$2;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.id_1 >= tmp2.id_1) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.tryIncPointers_6zsfpw_k$()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.decPointers_vy306j_k$()) {
                cur.remove_ldkf9o_k$();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.decPointers_vy306j_k$()) {
              tmp2.remove_ldkf9o_k$();
            }
          }
          tmp$ret$1 = tmp$ret$2;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$0 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.id_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    if (multiply(tmp0_0, fromInt(other)) < $this.get_receiversCounter_ne8ics_k$()) {
      startFrom.cleanPrev_rn0kss_k$();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.id_1 > id) {
      var tmp0_1 = segment.id_1;
      // Inline function 'kotlin.Long.times' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$7 = multiply(tmp0_1, fromInt(other_0));
      updateSendersCounterIfLower($this, tmp$ret$7);
      var tmp0_2 = segment.id_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      if (multiply(tmp0_2, fromInt(other_1)) < $this.get_receiversCounter_ne8ics_k$()) {
        segment.cleanPrev_rn0kss_k$();
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function findSegmentReceive($this, id, startFrom) {
  var tmp0 = $this.receiveSegment_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$2;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.id_1 >= tmp2.id_1) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.tryIncPointers_6zsfpw_k$()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.decPointers_vy306j_k$()) {
                cur.remove_ldkf9o_k$();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.decPointers_vy306j_k$()) {
              tmp2.remove_ldkf9o_k$();
            }
          }
          tmp$ret$1 = tmp$ret$2;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$0 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.id_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    if (multiply(tmp0_0, fromInt(other)) < $this.get_sendersCounter_mvbt0m_k$()) {
      startFrom.cleanPrev_rn0kss_k$();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
      var tmp0_1 = _get_bufferEndCounter__2d4hee($this);
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      tmp_1 = id <= divide(tmp0_1, fromInt(other_0));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp0_2 = $this.bufferEndSegment_1;
      $l$block_5: {
        // Inline function 'kotlinx.coroutines.internal.moveForward' call
        // Inline function 'kotlinx.atomicfu.loop' call
        while (true) {
          var cur_0 = tmp0_2.kotlinx$atomicfu$value;
          if (cur_0.id_1 >= segment.id_1) {
            break $l$block_5;
          }
          if (!segment.tryIncPointers_6zsfpw_k$()) {
            break $l$block_5;
          }
          if (tmp0_2.atomicfu$compareAndSet(cur_0, segment)) {
            if (cur_0.decPointers_vy306j_k$()) {
              cur_0.remove_ldkf9o_k$();
            }
            break $l$block_5;
          }
          if (segment.decPointers_vy306j_k$()) {
            segment.remove_ldkf9o_k$();
          }
        }
      }
    }
    var tmp_2;
    if (segment.id_1 > id) {
      var tmp0_3 = segment.id_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$11 = multiply(tmp0_3, fromInt(other_1));
      updateReceiversCounterIfLower($this, tmp$ret$11);
      var tmp0_4 = segment.id_1;
      // Inline function 'kotlin.Long.times' call
      var other_2 = get_SEGMENT_SIZE();
      if (multiply(tmp0_4, fromInt(other_2)) < $this.get_sendersCounter_mvbt0m_k$()) {
        segment.cleanPrev_rn0kss_k$();
      }
      tmp_2 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_2 = segment;
    }
    tmp_0 = tmp_2;
  }
  return tmp_0;
}
function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
  var tmp0 = $this.bufferEndSegment_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$0;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          var tmp$ret$2;
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.id_1 >= tmp2.id_1) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.tryIncPointers_6zsfpw_k$()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.decPointers_vy306j_k$()) {
                cur.remove_ldkf9o_k$();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.decPointers_vy306j_k$()) {
              tmp2.remove_ldkf9o_k$();
            }
          }
          tmp$ret$1 = tmp$ret$2;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$0 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$0;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
    incCompletedExpandBufferAttempts($this);
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.id_1 > id) {
      // Inline function 'kotlin.Long.plus' call
      var tmp_2 = add(currentBufferEndCounter, fromInt(1));
      var tmp0_0 = segment.id_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      var tmp$ret$7 = multiply(tmp0_0, fromInt(other));
      if ($this.bufferEnd_1.atomicfu$compareAndSet(tmp_2, tmp$ret$7)) {
        var tmp0_1 = segment.id_1;
        // Inline function 'kotlin.Long.times' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$8 = multiply(tmp0_1, fromInt(other_0));
        incCompletedExpandBufferAttempts($this, subtract(tmp$ret$8, currentBufferEndCounter));
      } else {
        incCompletedExpandBufferAttempts($this);
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
  var segment = startFrom;
  $l$loop: while (segment.id_1 < id) {
    var tmp0_elvis_lhs = segment.get_next_wor1vg_k$();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
  while (true) {
    $l$loop_0: while (segment.get_isRemoved_gzdz59_k$()) {
      var tmp1_elvis_lhs = segment.get_next_wor1vg_k$();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      segment = tmp_0;
    }
    var tmp0 = $this.bufferEndSegment_1;
    var tmp2 = segment;
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.internal.moveForward' call
      var tmp$ret$1;
      // Inline function 'kotlinx.atomicfu.loop' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (cur.id_1 >= tmp2.id_1) {
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (!tmp2.tryIncPointers_6zsfpw_k$()) {
          tmp$ret$0 = false;
          break $l$block_1;
        }
        if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
          if (cur.decPointers_vy306j_k$()) {
            cur.remove_ldkf9o_k$();
          }
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (tmp2.decPointers_vy306j_k$()) {
          tmp2.remove_ldkf9o_k$();
        }
      }
      tmp$ret$0 = tmp$ret$1;
    }
    if (tmp$ret$0)
      return Unit_instance;
  }
}
function updateSendersCounterIfLower($this, value) {
  var tmp$ret$0;
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.sendersAndCloseStatus_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var curCounter = cur & 1152921504606846975n;
    if (curCounter >= value)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp$ret$3 = convertToInt(shiftRight(cur, 60));
    var update = constructSendersAndCloseStatus(curCounter, tmp$ret$3);
    if ($this.sendersAndCloseStatus_1.atomicfu$compareAndSet(cur, update))
      return Unit_instance;
  }
  return tmp$ret$0;
}
function updateReceiversCounterIfLower($this, value) {
  var tmp$ret$0;
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.receivers_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    if (cur >= value)
      return Unit_instance;
    if ($this.receivers_1.atomicfu$compareAndSet(cur, value))
      return Unit_instance;
  }
  return tmp$ret$0;
}
function bindCancellationFunResult($this, $receiver) {
  return BufferedChannel$onCancellationChannelResultImplDoNotCall$ref($this);
}
function onCancellationChannelResultImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.onUndeliveredElement_1), ensureNotNull(ChannelResult__getOrNull_impl_f5e07h(element)), context);
}
function bindCancellationFun($this, $receiver, element) {
  return (_unused_var__etf5q3, _unused_var__etf5q3_0, context) => {
    callUndeliveredElement($receiver, element, context);
    return Unit_instance;
  };
}
function bindCancellationFun_0($this, $receiver) {
  return BufferedChannel$onCancellationImplDoNotCall$ref($this);
}
function onCancellationImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.onUndeliveredElement_1), element, context);
}
function access$_get_sendersAndCloseStatus__tvw29s($this) {
  return $this.sendersAndCloseStatus_1;
}
function access$_get_sendSegment__111kgq($this) {
  return $this.sendSegment_1;
}
function access$prepareSenderForSuspension($this, $receiver, segment, index) {
  return prepareSenderForSuspension($this, $receiver, segment, index);
}
function access$updateCellSend($this, segment, index, element, s, waiter, closed) {
  return updateCellSend($this, segment, index, element, s, waiter, closed);
}
function access$_get_isClosedForSend0__sm8f7a($this, $receiver) {
  return _get_isClosedForSend0__kxgf9m($this, $receiver);
}
function access$findSegmentSend($this, id, startFrom) {
  return findSegmentSend($this, id, startFrom);
}
function BufferedChannel$onCancellationChannelResultImplDoNotCall$ref(p0) {
  return constructCallableReference((p0_0, p1, p2) => {
    var tmp0 = p0;
    onCancellationChannelResultImplDoNotCall(tmp0, p0_0, p1.holder_1, p2);
    return Unit_instance;
  }, 3, 0, 1, 'onCancellationChannelResultImplDoNotCall', [p0]);
}
function BufferedChannel$onCancellationImplDoNotCall$ref(p0) {
  return constructCallableReference((p0_0, p1, p2) => {
    var tmp0 = p0;
    onCancellationImplDoNotCall(tmp0, p0_0, p1, p2);
    return Unit_instance;
  }, 3, 0, 2, 'onCancellationImplDoNotCall', [p0]);
}
var BufferedChannelClass;
function BufferedChannel() {
  if (BufferedChannelClass === VOID) {
    class $ {
      constructor(capacity, onUndeliveredElement) {
        onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
        this.capacity_1 = capacity;
        this.onUndeliveredElement_1 = onUndeliveredElement;
        // Inline function 'kotlin.require' call
        if (!(this.capacity_1 >= 0)) {
          var message = 'Invalid channel capacity: ' + this.capacity_1 + ', should be >=0';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString_0(message));
        }
        this.sendersAndCloseStatus_1 = atomic$long$1(0n);
        this.receivers_1 = atomic$long$1(0n);
        this.bufferEnd_1 = atomic$long$1(initialBufferEnd(this.capacity_1));
        this.completedExpandBuffersAndPauseFlag_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
        var firstSegment = new (ChannelSegment())(0n, null, this, 3);
        this.sendSegment_1 = atomic$ref$1(firstSegment);
        this.receiveSegment_1 = atomic$ref$1(firstSegment);
        var tmp = this;
        var tmp_0;
        if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
          var tmp_1 = get_NULL_SEGMENT();
          tmp_0 = tmp_1 instanceof ChannelSegment() ? tmp_1 : THROW_CCE();
        } else {
          tmp_0 = firstSegment;
        }
        tmp.bufferEndSegment_1 = atomic$ref$1(tmp_0);
        var tmp_2 = this;
        var tmp_3;
        if (this.onUndeliveredElement_1 == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_3 = (select, _unused_var__etf5q3, element) => (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) => {
            var tmp;
            if (!(element === get_CHANNEL_CLOSED())) {
              callUndeliveredElement(this.onUndeliveredElement_1, element, select.get_context_h02k06_k$());
              tmp = Unit_instance;
            }
            return Unit_instance;
          };
        }
        tmp_2.onUndeliveredElementReceiveCancellationConstructor_1 = tmp_3;
        this._closeCause_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
        this.closeHandler_1 = atomic$ref$1(null);
      }
      get_sendersCounter_mvbt0m_k$() {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        return this.sendersAndCloseStatus_1.kotlinx$atomicfu$value & 1152921504606846975n;
      }
      get_receiversCounter_ne8ics_k$() {
        return this.receivers_1.kotlinx$atomicfu$value;
      }
      *send_44jogj_k$(element, $completion) {
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
          var segment = access$_get_sendSegment__111kgq(this).kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s(this).atomicfu$getAndIncrement$long();
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var s = sendersAndCloseStatusCur & 1152921504606846975n;
            var closed = access$_get_isClosedForSend0__sm8f7a(this, sendersAndCloseStatusCur);
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(s, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$3 = modulo(s, fromInt(other_0));
            var i = convertToInt(tmp$ret$3);
            if (!(segment.id_1 === id)) {
              var tmp0_elvis_lhs = access$findSegmentSend(this, id, segment);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                var tmp_0;
                if (closed) {
                  yield* /*#__NOINLINE__*/onClosedSend(this, element, $completion);
                  break $l$block_5;
                } else {
                  continue $l$loop_0;
                }
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment = tmp;
            }
            switch (access$updateCellSend(this, segment, i, element, s, null, closed)) {
              case 0:
                segment.cleanPrev_rn0kss_k$();
                break $l$block_5;
              case 1:
                break $l$block_5;
              case 2:
                if (closed) {
                  segment.onSlotCleaned_do6lqz_k$();
                  yield* /*#__NOINLINE__*/onClosedSend(this, element, $completion);
                  break $l$block_5;
                }

                var tmp2_safe_receiver = (!(null == null) ? isInterface(null, Waiter()) : false) ? null : null;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  access$prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
                }

                // Inline function 'kotlinx.coroutines.assert' call

                break $l$block_5;
              case 4:
                if (s < this.get_receiversCounter_ne8ics_k$()) {
                  segment.cleanPrev_rn0kss_k$();
                }

                yield* /*#__NOINLINE__*/onClosedSend(this, element, $completion);
                break $l$block_5;
              case 5:
                segment.cleanPrev_rn0kss_k$();
                continue $l$loop_0;
              case 3:
                var segm = segment;
                yield* /*#__NOINLINE__*/sendOnNoWaiterSuspend(this, segm, i, element, s, $completion);
                break $l$block_5;
            }
          }
        }
        return Unit_instance;
      }
      trySend_62dpg8_k$(element) {
        if (shouldSendSuspend0(this, this.sendersAndCloseStatus_1.kotlinx$atomicfu$value))
          return Companion_getInstance().failure_q0nifh_k$();
        var tmp4 = get_INTERRUPTED_SEND();
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
          var segment = access$_get_sendSegment__111kgq(this).kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s(this).atomicfu$getAndIncrement$long();
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var s = sendersAndCloseStatusCur & 1152921504606846975n;
            var closed = access$_get_isClosedForSend0__sm8f7a(this, sendersAndCloseStatusCur);
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(s, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$3 = modulo(s, fromInt(other_0));
            var i = convertToInt(tmp$ret$3);
            if (!(segment.id_1 === id)) {
              var tmp0_elvis_lhs = access$findSegmentSend(this, id, segment);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                var tmp_0;
                if (closed) {
                  tmp$ret$0 = Companion_getInstance().closed_xuwu5z_k$(this.get_sendException_qpq1ry_k$());
                  break $l$block_5;
                } else {
                  continue $l$loop_0;
                }
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment = tmp;
            }
            switch (access$updateCellSend(this, segment, i, element, s, tmp4, closed)) {
              case 0:
                segment.cleanPrev_rn0kss_k$();
                tmp$ret$0 = Companion_getInstance().success_tizbw6_k$(Unit_instance);
                break $l$block_5;
              case 1:
                tmp$ret$0 = Companion_getInstance().success_tizbw6_k$(Unit_instance);
                break $l$block_5;
              case 2:
                if (closed) {
                  segment.onSlotCleaned_do6lqz_k$();
                  tmp$ret$0 = Companion_getInstance().closed_xuwu5z_k$(this.get_sendException_qpq1ry_k$());
                  break $l$block_5;
                }

                var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter()) : false) ? tmp4 : null;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  access$prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
                }

                segment.onSlotCleaned_do6lqz_k$();
                tmp$ret$0 = Companion_getInstance().failure_q0nifh_k$();
                break $l$block_5;
              case 4:
                if (s < this.get_receiversCounter_ne8ics_k$()) {
                  segment.cleanPrev_rn0kss_k$();
                }

                tmp$ret$0 = Companion_getInstance().closed_xuwu5z_k$(this.get_sendException_qpq1ry_k$());
                break $l$block_5;
              case 5:
                segment.cleanPrev_rn0kss_k$();
                continue $l$loop_0;
              case 3:
                // Inline function 'kotlin.error' call

                var message = 'unexpected';
                throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
            }
          }
        }
        return tmp$ret$0;
      }
      onReceiveEnqueued_xthhlc_k$() {
      }
      onReceiveDequeued_4w5qpk_k$() {
      }
      *receive_awoumx_k$($completion) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment = this.receiveSegment_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (this.get_isClosedForReceive_v0r77d_k$()) {
              throw recoverStackTrace(_get_receiveException__foorc1(this));
            }
            var r = this.receivers_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$3 = modulo(r, fromInt(other_0));
            var i = convertToInt(tmp$ret$3);
            if (!(segment.id_1 === id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment = tmp;
            }
            var updCellResult = updateCellReceive(this, segment, i, r, null);
            var tmp_0;
            if (updCellResult === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(null == null) ? isInterface(null, Waiter()) : false) ? null : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(this, tmp1_safe_receiver, segment, i);
              }
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
            } else if (updCellResult === get_FAILED()) {
              if (r < this.get_sendersCounter_mvbt0m_k$()) {
                segment.cleanPrev_rn0kss_k$();
              }
              continue $l$loop_0;
            } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
              var segm = segment;
              tmp_0 = yield* /*#__NOINLINE__*/receiveOnNoWaiterSuspend(this, segm, i, r, $completion);
            } else {
              segment.cleanPrev_rn0kss_k$();
              return updCellResult;
            }
            tmp$ret$0 = tmp_0;
            break $l$block_0;
          }
        }
        return tmp$ret$0;
      }
      dropFirstElementUntilTheSpecifiedCellIsInTheBuffer_l7hcju_k$(globalCellIndex) {
        // Inline function 'kotlinx.coroutines.assert' call
        var segment = this.receiveSegment_1.kotlinx$atomicfu$value;
        $l$loop_0: while (true) {
          var r = this.receivers_1.kotlinx$atomicfu$value;
          // Inline function 'kotlin.Long.plus' call
          var other = this.capacity_1;
          var tmp0 = add(r, fromInt(other));
          // Inline function 'kotlin.math.max' call
          var b = _get_bufferEndCounter__2d4hee(this);
          if (globalCellIndex < (tmp0 >= b ? tmp0 : b))
            return Unit_instance;
          // Inline function 'kotlin.Long.plus' call
          var tmp$ret$3 = add(r, fromInt(1));
          if (!this.receivers_1.atomicfu$compareAndSet(r, tmp$ret$3))
            continue $l$loop_0;
          // Inline function 'kotlin.Long.div' call
          var other_0 = get_SEGMENT_SIZE();
          var id = divide(r, fromInt(other_0));
          // Inline function 'kotlin.Long.rem' call
          var other_1 = get_SEGMENT_SIZE();
          var tmp$ret$5 = modulo(r, fromInt(other_1));
          var i = convertToInt(tmp$ret$5);
          if (!(segment.id_1 === id)) {
            var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            segment = tmp;
          }
          var updCellResult = updateCellReceive(this, segment, i, r, null);
          if (updCellResult === get_FAILED()) {
            if (r < this.get_sendersCounter_mvbt0m_k$()) {
              segment.cleanPrev_rn0kss_k$();
            }
          } else {
            segment.cleanPrev_rn0kss_k$();
            var tmp1_safe_receiver = this.onUndeliveredElement_1;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp1_safe_receiver, updCellResult);
            if (tmp2_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              throw tmp2_safe_receiver;
            }
          }
        }
      }
      waitExpandBufferCompletion_nil576_k$(globalIndex) {
        if (_get_isRendezvousOrUnlimited__3mdufi(this))
          return Unit_instance;
        while (_get_bufferEndCounter__2d4hee(this) <= globalIndex) {
        }
        // Inline function 'kotlin.repeat' call
        var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var b = _get_bufferEndCounter__2d4hee(this);
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var ebCompleted = this.completedExpandBuffersAndPauseFlag_1.kotlinx$atomicfu$value & 4611686018427387903n;
            if (b === ebCompleted && b === _get_bufferEndCounter__2d4hee(this))
              return Unit_instance;
          }
           while (inductionVariable < times);
        var tmp0 = this.completedExpandBuffersAndPauseFlag_1;
        $l$block: {
          // Inline function 'kotlinx.atomicfu.update' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var tmp$ret$5 = cur & 4611686018427387903n;
            var upd = constructEBCompletedAndPauseFlag(tmp$ret$5, true);
            if (tmp0.atomicfu$compareAndSet(cur, upd)) {
              break $l$block;
            }
          }
        }
        while (true) {
          var b_0 = _get_bufferEndCounter__2d4hee(this);
          var ebCompletedAndBit = this.completedExpandBuffersAndPauseFlag_1.kotlinx$atomicfu$value;
          // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
          var ebCompleted_0 = ebCompletedAndBit & 4611686018427387903n;
          // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
          var pauseExpandBuffers = !((ebCompletedAndBit & 4611686018427387904n) === 0n);
          if (b_0 === ebCompleted_0 && b_0 === _get_bufferEndCounter__2d4hee(this)) {
            var tmp0_0 = this.completedExpandBuffersAndPauseFlag_1;
            $l$block_0: {
              // Inline function 'kotlinx.atomicfu.update' call
              while (true) {
                var cur_0 = tmp0_0.kotlinx$atomicfu$value;
                // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
                var tmp$ret$10 = cur_0 & 4611686018427387903n;
                var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$10, false);
                if (tmp0_0.atomicfu$compareAndSet(cur_0, upd_0)) {
                  break $l$block_0;
                }
              }
            }
            return Unit_instance;
          }
          if (!pauseExpandBuffers) {
            this.completedExpandBuffersAndPauseFlag_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
          }
        }
      }
      iterator_jk1svi_k$() {
        return new (BufferedChannelIterator())(this);
      }
      get_closeCause_gbqkm2_k$() {
        var tmp = this._closeCause_1.kotlinx$atomicfu$value;
        return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
      }
      get_sendException_qpq1ry_k$() {
        var tmp0_elvis_lhs = this.get_closeCause_gbqkm2_k$();
        return tmp0_elvis_lhs == null ? ClosedSendChannelException().new_kotlinx_coroutines_channels_ClosedSendChannelException_f413rp_k$('Channel was closed') : tmp0_elvis_lhs;
      }
      onClosedIdempotent_yws25w_k$() {
      }
      close_ukldxa_k$(cause) {
        return this.closeOrCancelImpl_46q3uk_k$(cause, false);
      }
      cancel_hkmm2i_k$(cause) {
        this.cancelImpl_1ciz43_k$(cause);
      }
      cancelImpl_1ciz43_k$(cause) {
        return this.closeOrCancelImpl_46q3uk_k$(cause == null ? CancellationException().new_kotlin_coroutines_cancellation_CancellationException_kxgi4u_k$('Channel was cancelled') : cause, true);
      }
      closeOrCancelImpl_46q3uk_k$(cause, cancel) {
        if (cancel) {
          markCancellationStarted(this);
        }
        var closedByThisOperation = this._closeCause_1.atomicfu$compareAndSet(get_NO_CLOSE_CAUSE(), cause);
        if (cancel) {
          markCancelled(this);
        } else {
          markClosed(this);
        }
        completeCloseOrCancel(this);
        // Inline function 'kotlin.also' call
        this.onClosedIdempotent_yws25w_k$();
        if (closedByThisOperation) {
          invokeCloseHandler(this);
        }
        return closedByThisOperation;
      }
      invokeOnClose_xlde4o_k$(handler) {
        if (this.closeHandler_1.atomicfu$compareAndSet(null, handler)) {
          return Unit_instance;
        }
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.closeHandler_1;
        while (true) {
          var cur = this_0.kotlinx$atomicfu$value;
          if (cur === get_CLOSE_HANDLER_CLOSED()) {
            if (this.closeHandler_1.atomicfu$compareAndSet(get_CLOSE_HANDLER_CLOSED(), get_CLOSE_HANDLER_INVOKED())) {
              handler(this.get_closeCause_gbqkm2_k$());
              return Unit_instance;
            }
          } else if (cur === get_CLOSE_HANDLER_INVOKED()) {
            // Inline function 'kotlin.error' call
            var message = 'Another handler was already registered and successfully invoked';
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message));
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Another handler is already registered: ' + toString(cur);
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString_0(message_0));
          }
        }
      }
      get_isConflatedDropOldest_qp2q39_k$() {
        return false;
      }
      get_isClosedForSend_ajczci_k$() {
        return _get_isClosedForSend0__kxgf9m(this, this.sendersAndCloseStatus_1.kotlinx$atomicfu$value);
      }
      get_isClosedForReceive_v0r77d_k$() {
        return _get_isClosedForReceive0__f7qknl(this, this.sendersAndCloseStatus_1.kotlinx$atomicfu$value);
      }
      hasElements_2busqs_k$() {
        $l$loop: while (true) {
          var segment = this.receiveSegment_1.kotlinx$atomicfu$value;
          var r = this.get_receiversCounter_ne8ics_k$();
          var s = this.get_sendersCounter_mvbt0m_k$();
          if (s <= r)
            return false;
          // Inline function 'kotlin.Long.div' call
          var other = get_SEGMENT_SIZE();
          var id = divide(r, fromInt(other));
          if (!(segment.id_1 === id)) {
            var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              var tmp_0;
              if (this.receiveSegment_1.kotlinx$atomicfu$value.id_1 < id) {
                return false;
              } else {
                continue $l$loop;
              }
            } else {
              tmp = tmp0_elvis_lhs;
            }
            segment = tmp;
          }
          segment.cleanPrev_rn0kss_k$();
          // Inline function 'kotlin.Long.rem' call
          var other_0 = get_SEGMENT_SIZE();
          var tmp$ret$1 = modulo(r, fromInt(other_0));
          var i = convertToInt(tmp$ret$1);
          if (isCellNonEmpty(this, segment, i, r))
            return true;
          // Inline function 'kotlin.Long.plus' call
          var tmp$ret$2 = add(r, fromInt(1));
          this.receivers_1.atomicfu$compareAndSet(r, tmp$ret$2);
        }
      }
      toString() {
        var sb = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        var this_0 = this.sendersAndCloseStatus_1.kotlinx$atomicfu$value;
        var tmp0_subject = convertToInt(shiftRight(this_0, 60));
        if (tmp0_subject === 2) {
          sb.append_22ad7x_k$('closed,');
        } else if (tmp0_subject === 3) {
          sb.append_22ad7x_k$('cancelled,');
        }
        sb.append_22ad7x_k$('capacity=' + this.capacity_1 + ',');
        sb.append_22ad7x_k$('data=[');
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = listOf([this.receiveSegment_1.kotlinx$atomicfu$value, this.sendSegment_1.kotlinx$atomicfu$value, this.bufferEndSegment_1.kotlinx$atomicfu$value]);
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (!(element === get_NULL_SEGMENT())) {
            destination.add_utx5q5_k$(element);
          }
        }
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.minBy' call
          var iterator = destination.iterator_jk1svi_k$();
          if (!iterator.hasNext_bitz1p_k$())
            throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
          var minElem = iterator.next_20eer_k$();
          if (!iterator.hasNext_bitz1p_k$()) {
            tmp$ret$4 = minElem;
            break $l$block;
          }
          var minValue = minElem.id_1;
          do {
            var e = iterator.next_20eer_k$();
            var v = e.id_1;
            if (compareTo(minValue, v) > 0) {
              minElem = e;
              minValue = v;
            }
          }
           while (iterator.hasNext_bitz1p_k$());
          tmp$ret$4 = minElem;
        }
        var firstSegment = tmp$ret$4;
        var r = this.get_receiversCounter_ne8ics_k$();
        var s = this.get_sendersCounter_mvbt0m_k$();
        var segment = firstSegment;
        append_elements: while (true) {
          var inductionVariable = 0;
          var last_0 = get_SEGMENT_SIZE();
          if (inductionVariable < last_0)
            process_cell: do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0_0 = segment.id_1;
              // Inline function 'kotlin.Long.times' call
              var other = get_SEGMENT_SIZE();
              // Inline function 'kotlin.Long.plus' call
              var this_1 = multiply(tmp0_0, fromInt(other));
              var globalCellIndex = add(this_1, fromInt(i));
              if (globalCellIndex >= s && globalCellIndex >= r)
                break append_elements;
              var cellState = segment.getState_jak5mi_k$(i);
              var element_0 = segment.getElement_ye1phr_k$(i);
              var tmp;
              if (!(cellState == null) ? isInterface(cellState, CancellableContinuation()) : false) {
                tmp = (s <= globalCellIndex ? globalCellIndex < r : false) ? 'receive' : (r <= globalCellIndex ? globalCellIndex < s : false) ? 'send' : 'cont';
              } else {
                if (!(cellState == null) ? isInterface(cellState, SelectInstance()) : false) {
                  tmp = (s <= globalCellIndex ? globalCellIndex < r : false) ? 'onReceive' : (r <= globalCellIndex ? globalCellIndex < s : false) ? 'onSend' : 'select';
                } else {
                  if (cellState instanceof ReceiveCatching()) {
                    tmp = 'receiveCatching';
                  } else {
                    if (cellState instanceof SendBroadcast()) {
                      tmp = 'sendBroadcast';
                    } else {
                      if (cellState instanceof WaiterEB()) {
                        tmp = 'EB(' + cellState.toString() + ')';
                      } else {
                        if (equals(cellState, get_RESUMING_BY_RCV()) || equals(cellState, get_RESUMING_BY_EB())) {
                          tmp = 'resuming_sender';
                        } else {
                          if (cellState == null || (equals(cellState, get_IN_BUFFER()) || equals(cellState, get_DONE_RCV())) || (equals(cellState, get_POISONED()) || equals(cellState, get_INTERRUPTED_RCV()) || (equals(cellState, get_INTERRUPTED_SEND()) || equals(cellState, get_CHANNEL_CLOSED())))) {
                            continue process_cell;
                          } else {
                            tmp = toString_0(cellState);
                          }
                        }
                      }
                    }
                  }
                }
              }
              var cellStateString = tmp;
              if (!(element_0 == null)) {
                sb.append_22ad7x_k$('(' + cellStateString + ',' + toString_0(element_0) + '),');
              } else {
                sb.append_22ad7x_k$(cellStateString + ',');
              }
            }
             while (inductionVariable < last_0);
          var tmp4_elvis_lhs = segment.get_next_wor1vg_k$();
          var tmp_0;
          if (tmp4_elvis_lhs == null) {
            break append_elements;
          } else {
            tmp_0 = tmp4_elvis_lhs;
          }
          segment = tmp_0;
        }
        if (last(sb) === _Char___init__impl__6a9atx(44)) {
          sb.deleteAt_mq1vvq_k$(sb.get_length_g42xv3_k$() - 1 | 0);
        }
        sb.append_22ad7x_k$(']');
        return sb.toString();
      }
    }
    protoOf($).close$default_kcbl7u_k$ = close$default;
    protoOf($).cancel$default_880p35_k$ = cancel$default;
    initMetadataForClass($, 'BufferedChannel', VOID, VOID, [ReceiveChannel(), SendChannel()], [1, 4, 0, 3]);
    BufferedChannelClass = $;
  }
  return BufferedChannelClass;
}
var WaiterEBClass;
function WaiterEB() {
  if (WaiterEBClass === VOID) {
    class $ {
      constructor(waiter) {
        this.waiter_1 = waiter;
      }
      toString() {
        return 'WaiterEB(' + toString_0(this.waiter_1) + ')';
      }
    }
    initMetadataForClass($, 'WaiterEB');
    WaiterEBClass = $;
  }
  return WaiterEBClass;
}
function initialBufferEnd(capacity) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  switch (capacity) {
    case 0:
      return 0n;
    case 2147483647:
      return 9223372036854775807n;
    default:
      return fromInt(capacity);
  }
}
var ReceiveCatchingClass;
function ReceiveCatching() {
  if (ReceiveCatchingClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ReceiveCatching', VOID, VOID, [Waiter()]);
    ReceiveCatchingClass = $;
  }
  return ReceiveCatchingClass;
}
function tryResume0(_this__u8e3s4, value, onCancellation) {
  onCancellation = onCancellation === VOID ? null : onCancellation;
  _init_properties_BufferedChannel_kt__d6uc4y();
  // Inline function 'kotlin.let' call
  var token = _this__u8e3s4.tryResume_gmd8sc_k$(value, null, onCancellation);
  var tmp;
  if (!(token == null)) {
    _this__u8e3s4.completeResume_fabtk_k$(token);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function constructEBCompletedAndPauseFlag(counter, pauseEB) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return add(pauseEB ? 4611686018427387904n : 0n, counter);
}
function constructSendersAndCloseStatus(counter, closeStatus) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return add(shiftLeft(fromInt(closeStatus), 60), counter);
}
function createSegmentFunction() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return createSegment$ref();
}
function createSegment(id, prev) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return new (ChannelSegment())(id, prev, prev.get_channel_dhi7tm_k$(), 0);
}
function createSegment$ref() {
  return constructCallableReference((p0, p1) => createSegment(p0, p1), 2, 0, 3, 'createSegment');
}
var properties_initialized_BufferedChannel_kt_58tjvw;
function _init_properties_BufferedChannel_kt__d6uc4y() {
  if (!properties_initialized_BufferedChannel_kt_58tjvw) {
    properties_initialized_BufferedChannel_kt_58tjvw = true;
    NULL_SEGMENT = new (ChannelSegment())(-1n, null, null, 0);
    SEGMENT_SIZE = systemProp('kotlinx.coroutines.bufferedChannel.segmentSize', 32);
    EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp('kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations', 10000);
    BUFFERED = new (Symbol())('BUFFERED');
    IN_BUFFER = new (Symbol())('SHOULD_BUFFER');
    RESUMING_BY_RCV = new (Symbol())('S_RESUMING_BY_RCV');
    RESUMING_BY_EB = new (Symbol())('RESUMING_BY_EB');
    POISONED = new (Symbol())('POISONED');
    DONE_RCV = new (Symbol())('DONE_RCV');
    INTERRUPTED_SEND = new (Symbol())('INTERRUPTED_SEND');
    INTERRUPTED_RCV = new (Symbol())('INTERRUPTED_RCV');
    CHANNEL_CLOSED = new (Symbol())('CHANNEL_CLOSED');
    SUSPEND = new (Symbol())('SUSPEND');
    SUSPEND_NO_WAITER = new (Symbol())('SUSPEND_NO_WAITER');
    FAILED = new (Symbol())('FAILED');
    NO_RECEIVE_RESULT = new (Symbol())('NO_RECEIVE_RESULT');
    CLOSE_HANDLER_CLOSED = new (Symbol())('CLOSE_HANDLER_CLOSED');
    CLOSE_HANDLER_INVOKED = new (Symbol())('CLOSE_HANDLER_INVOKED');
    NO_CLOSE_CAUSE = new (Symbol())('NO_CLOSE_CAUSE');
  }
}
//region block: exports
export {
  access$findSegmentSend as access$findSegmentSend1rq2hoj4hiojx,
  access$_get_isClosedForSend0__sm8f7a as access$_get_isClosedForSend0__sm8f7ad6w3wkg5hm6q,
  access$prepareSenderForSuspension as access$prepareSenderForSuspensionhe35w06znfdm,
  access$_get_sendSegment__111kgq as access$_get_sendSegment__111kgq3e41ruajnjr0f,
  access$_get_sendersAndCloseStatus__tvw29s as access$_get_sendersAndCloseStatus__tvw29s1hsu1qz6ckz7z,
  access$updateCellSend as access$updateCellSend1n524tbdorfh1,
  get_BUFFERED as get_BUFFERED29hqqqmuwfwgo,
  BufferedChannel as BufferedChannel3lgkhzot5gmk6,
  get_SEGMENT_SIZE as get_SEGMENT_SIZE3avqnmtdqy204,
};
//endregion

//# sourceMappingURL=BufferedChannel.mjs.map
